import { Box, Heading, Text, Flex } from "@chakra-ui/react";
import { LandingHeader } from "../../layouts/Header";
import { FooterInfo } from "../../layouts/Footer";

export function NotFound() {
    return (
        <Flex flexDirection="column" height="100vh">
            <Box width="full" position="sticky" top="0" zIndex="sticky">
                <LandingHeader />
            </Box>

            {/* Scrollable Main Content */}
            <Flex as="main" flex="1" direction="column" justifyContent="center" alignItems="center">
                <Heading size="xl" mb={4}>
                    404 - Not Found
                </Heading>
                <Text fontSize="lg" mb={8}>
                    Sorry, the page you are looking for does not exist or has been moved.
                </Text>
            </Flex>

            <FooterInfo />
        </Flex>
    );
}
